import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getFooterItems } from '../../services/footer';

const footerItemsInitialValue = {
  image: "",
  name: "",
  portal: "",
  message: "",
  version: "",
  return: false
}

function index() {
  const { pathname } = useLocation()
  const [footerItems, setFooterItems] = useState(footerItemsInitialValue)

  useEffect(() => {
    (async () => {
      if(pathname === '/') return setFooterItems(footerItemsInitialValue)
      if(footerItems.return) return
      const res = await getFooterItems()
      if (res) setFooterItems(res as any)
    })()
  }, [pathname])

  return (
    <>
      {pathname !== '/' && (
        <div className="footer">
          <div className="footer__text">
            {`${footerItems.portal} version ${footerItems.version}`}
          </div>
          <div className="footer__text">
            Logged as {footerItems.name}
          </div>
        </div>
      )}
    </>
  )
}

export default index